module.exports = __webpack_public_path__ + "img/bind_success_bg.1cb4d413.png";